import React from 'react';
import * as styles from './oops.module.css';

// MARK: add a reset button here
const FriendlyOops = ({ location, error, errorInfo }) => {

    let clues;

    if (location?.state && location.state.message) {
        clues = location.state.message;
    } else if (error) {
        clues = error;
    } else {
        clues = 'no error details';
    }

    const stack = errorInfo ? `\n\n${errorInfo}` : null;

    const emailSuffix = '\n\nYou can also include a phone number. Let\'s call in the friendzone detectives!\n\nxo Groovy Support';

    return (
        <div className={styles.oopsPage}>
            <div className={styles.oopsPage__background} />
            <div className={styles.oopsPage__clues}>
                <h1>OOPS</h1>
                <h2>Something went seriously pop on our side 😔</h2>
                <h2>Maybe the morning afterwards holds a clue to our naughty.</h2>
                <h2>________________________________________________________________________</h2>
                <p className={styles.oopsPage__dateLine}>{utcDate + ': ' + 'Oooh... so we found a Friendzone Banana cuddling a French Letter. Our techsters would looove to analyse the scene!'}</p>
                {clues && <h3>whisper: {clues}</h3>}
                {stack && <h3>replay: {stack}</h3>}
                <br/>
                <button className={styles.oopsPage__cluesButton}>
                    <a href={`mailto:techsters@groovyparachute.com?subject=${encodeURIComponent('Groovy Parachute  >>>------->  EARLY MORNING CLUES')}&body=${encodeURIComponent(clues ? utcDate + ': ' + clues + (stack ? stack : '') + emailSuffix : 'Time of event (UTC) -> ' + utcDate + emailSuffix)}`}>Send us the clues</a>
                </button>
                <span className={styles.oopsPage__imageCredit}>Photography by <span className={styles.oopsPage__imageCreditName}>Nataliya Voitkevich</span> via Pexels.com</span>
            </div>
        </div>)

}

//
// Time on customer's machine.
//
const utcDate = (() => {
    return new Date().toString(); // Thu May 30 2024 07:11:27 GMT+0200 (South Africa Standard Time)
})();

export default FriendlyOops;